import React, { useState } from "react";
import "./styles/HoverDropdown.css";

function HoverDropdown({
  downloadTxtFile,
  text,
  handleTitleChange,
  exportfeatures,
  handleTabChange,
  setSelectedWeights,
  handleExportTypeChange,
  handleSelection,
  feature,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };

  const onSelection = (value, displayText) => {
    if (feature === 1) {
      downloadTxtFile(value);
    } else if (feature === 2) {
      handleTabChange(value);
    } else if (feature === 3) {
      setSelectedWeights(value);
    } else if (feature === 4) {
      handleExportTypeChange(value);
    } else if (feature === 5) {
      handleTitleChange("type", displayText);
    } else if (feature === 6 && handleSelection) {
      handleSelection(displayText);
    }
  };

  return (
    <div
      className="hover-dropdown"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="hover-text">{text}</span>

      {isDropdownOpen && (
        <div className="dropdown-menu">
          {feature === 1 &&
            exportfeatures?.map((x, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => onSelection(x.type, x.text)}
              >
                {x.text}
              </div>
            ))}

          {feature === 2 &&
            exportfeatures?.map((x, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => onSelection(x.name, x.name)}
              >
                {x.name}
              </div>
            ))}

          {feature === 3 &&
            exportfeatures &&
            Object.keys(exportfeatures).map((x, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => onSelection(x, x)}
              >
                {x}
              </div>
            ))}

          {feature === 4 &&
            exportfeatures?.map((x, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => onSelection(x.value, x.text)}
              >
                {x.text}
              </div>
            ))}

          {feature === 5 &&
            exportfeatures?.map((x, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => onSelection(x.text, x.text)}
              >
                {x.text}
              </div>
            ))}

          {feature === 6 &&
            exportfeatures?.map((featureItem, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => handleSelection(featureItem.value)}
              >
                {featureItem.label || featureItem.value}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default HoverDropdown;
